<div (click)="onClick($event)">
  @if (hasMermaid()) {
    @if (isMermaidReady()) {
      <markdown mermaid [data]="content()" [mermaidOptions]="mermaidOptions()"></markdown>
    } @else if (isMermaidLoadFailed()) {
      <markdown [data]="mermaidFallbackContent()"></markdown>
    } @else {
      <app-loader></app-loader>
    }
  } @else {
    <markdown [data]="content()"></markdown>
  }
</div>
